import { render, staticRenderFns } from "./Contatti.vue?vue&type=template&id=fb8633fe&scoped=true"
import script from "./Contatti.vue?vue&type=script&lang=js"
export * from "./Contatti.vue?vue&type=script&lang=js"
import style0 from "./Contatti.vue?vue&type=style&index=0&id=fb8633fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8633fe",
  null
  
)

export default component.exports